import { WhatsAppHelp } from './WhatsAppHelp';

export function SiteFooter() {
  return (
    <footer className="border-t border-line bg-surface mt-auto pb-[var(--bottom-nav-space)] md:pb-0">
      <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-ink-soft">
        <span className="font-display text-lg leading-none text-ink tracking-tight">
          Physio<span className="text-sand">EDGE</span>
        </span>
        <WhatsAppHelp label="WhatsApp us for help" />
      </div>
    </footer>
  );
}
